import IFunction from "src/components/container/Tree/CheckFunctions/Entity/Interface/IFunction";
import FunctionBuilder from "src/components/container/Tree/CheckFunctions/Entity/Builder/FunctionBuilder";
import FunctionModel from "src/models/FunctionModel";

/**
 * Parsea una lista de funciones para que lo entienda el componente
 * Tree/CheckFunctions
 * 
 * NOTA: Utiliza una funci�n recursiva, tener en cuenta para la cantidad de
 * anidamiento de funciones ya que afecta la performance de la carga.
 * @param {FunctionModel[]} data Lista de funciones obtenidas del servidor.
 * @returns {Promise<IFunction[]>}
 */
const ParserFunctions = (data: FunctionModel[]): Promise<IFunction[]> => {
  /**
   * Agrega los elementos hijos en la lista de funciones.
   * 
   * Nota: Esta funci�n es recursiva, si posee muchos niveles
   * podria afectar el rendimiento de la aplicaci�n.
   * @param {number} id identificador funci�n padre
   * @returns {IFunction[]} Arreglo de funciones formateado para mostrar en el �rbol de funciones.
   */
  const addChild = (id: number): IFunction[] | null => {
    const childFunct: IFunction[] = [];
    data.filter((elem) => elem.Function_Id === id)
      .map(
        (value: FunctionModel) => {
          const chFunct = new FunctionBuilder()
            .setId(value.Id)
            .setName(value.Name);

          const chList: IFunction[] | null = addChild(value.Id);
          if (chList && chList.length > 0) {
            chFunct.setRelateListFunction(chList);
          }

          childFunct.push(chFunct.get());
        }
    );

    if (childFunct.length > 0) {
      return childFunct;
    } else {
      return null;
    }
  }

  return new Promise(
    (resolve, reject) => {
      if (data.length === 0) reject("Function list is empty");
      const functions: IFunction[] = [];
      // Se agrega el primer nivel al arreglo.
      data.filter((elem) => elem.Function_Id === null)
        .sort((a, b) => b.Id - a.Id)
        .map(
          (value: FunctionModel) => {
            const newFunction = new FunctionBuilder()
              .setId(value.Id)
              .setName(value.Name);

            const lstChilds: IFunction[] | null = addChild(value.Id);
            if (lstChilds) {
              newFunction.setRelateListFunction(lstChilds);
            }

            functions.push(newFunction.get());
          }
      );
      resolve(functions);
    }
  )
}

export default ParserFunctions;
